import {GetProvidersDetailsMedicalGuide} from 'domain/usecases';
import {RemoteGetProvidersDetailsMedicalGuide} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetProvidersDetailsMedicalGuide = (): GetProvidersDetailsMedicalGuide =>
	new RemoteGetProvidersDetailsMedicalGuide(
		makeBFFApiUrl(GuideFlowEndpoints.medicalGuideProvidersDetails),
		makeAuthorizeHttpClientDecorator(),
	);
